import { useEffect, useState } from "react";
import axios from "../../../axios"; // Adjust the path as necessary
import dayjs from "dayjs";

export default function SalesReportPage() {
    const [data, setData] = useState([]);
    const [range, setRange] = useState({
        start: dayjs().startOf("month").format("YYYY-MM-DD"),
        end: dayjs().endOf("month").format("YYYY-MM-DD"),
    });
    const [loading, setLoading] = useState(false);

    const fetchData = async () => {
        setLoading(true);
        try {
            const res = await axios.get(`/admin/sales-report/by-date`, {
                params: {
                    start: range.start,
                    end: range.end,
                },
            });
            setData(res.data);
        } catch (err) {
            console.error("Gagal fetch laporan:", err);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchData();
    }, []);

    const totalSales = data.reduce((acc, d) => acc + d.price, 0);

    const handleInputChange = (e) => {
        setRange({ ...range, [e.target.name]: e.target.value });
    };

    const handleReset = () => {
        setRange({
            start: dayjs().startOf("month").format("YYYY-MM-DD"),
            end: dayjs().endOf("month").format("YYYY-MM-DD"),
        });
        fetchData();
    };

    return (
        <div className="card mt-24">
            <div className="card-header border-bottom">
                <h5>Laporan Penjualan</h5>
            </div>

            <div className="card-body">
                <div className="d-flex align-items-end gap-3 mb-3">
                    <div>
                        <label className="form-label">Dari Tanggal</label>
                        <input
                            type="date"
                            name="start"
                            value={range.start}
                            className="form-control"
                            onChange={handleInputChange}
                        />
                    </div>
                    <div>
                        <label className="form-label">Sampai Tanggal</label>
                        <input
                            type="date"
                            name="end"
                            value={range.end}
                            className="form-control"
                            onChange={handleInputChange}
                        />
                    </div>
                    <div>
                        <button onClick={fetchData} className="btn btn-main">Filter</button>
                        <button onClick={handleReset} className="btn btn-secondary ms-2">Reset</button>
                    </div>
                </div>

                {loading ? (
                    <p>Loading...</p>
                ) : (
                    <>
                        <table className="table table-bordered">
                            <thead>
                                <tr>
                                    <th>Tanggal</th>
                                    <th>Produk</th>
                                    <th>Pelanggan</th>
                                    <th>Harga</th>
                                </tr>
                            </thead>
                            <tbody>
                                {data.map((d, i) => (
                                    <tr key={i}>
                                        <td>{dayjs(d.date).format("DD MMM YYYY")}</td>
                                        <td>{d.product_name}</td>
                                        <td>{d.customer_name}</td>
                                        <td>Rp{d.price.toLocaleString("id-ID")}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>

                        <h5>Total Penjualan: <strong>Rp{totalSales.toLocaleString("id-ID")}</strong></h5>
                    </>
                )}
            </div>
        </div>
    );
}
